import React from "react";
import {css, CSSObject, forBrands, styled, Theme} from "@core-ui/react-stitch";
import {StyledContainerProps, StyledContainerThemedProps} from "../types";

const getFontSize = (theme: Theme) =>
  forBrands(theme, {
    gap: () => "1.067rem",
    gapfs: () => "1.067rem",
    br: () => "1.25rem",
    brfs: () => "1.25rem",
    on: () => "0.867rem",
    default: () => "1rem",
  }) as CSSObject;

const getColor = (theme: Theme) =>
  forBrands(theme, {
    br: () => theme.color.b1,
    brfs: () => theme.color.b1,
    default: () => theme.color.g2,
  }) as CSSObject;

const getBrandedMargins = (theme: Theme) =>
  forBrands(theme, {
    gap: () => "margin-bottom: 2rem",
    gapfs: () => "margin-bottom: 2rem",
    at: () => "margin: 0 0.5rem 1.25rem 0.5rem",
    br: () => "margin: 0",
    brfs: () => "margin: 0",
    default: () => "margin: 0 0.5rem",
  }) as CSSObject;

const getBRPadding = (isMobile: boolean) =>
  isMobile ? "1rem 0 1rem 0" : "2rem 0";

const getPadding = (theme: Theme, isMobile = false) =>
  forBrands(theme, {
    br: () => getBRPadding(isMobile),
    brfs: () => getBRPadding(isMobile),
    at: () => "0.3rem 0.5rem",
    on: () => "1rem 0",
    default: () => "0",
  }) as CSSObject;

const getLineHeight = (theme: Theme) =>
  forBrands(theme, {
    on: () => "1.38",
    default: () => "normal",
  }) as CSSObject;

const customContainerStyles = (theme: Theme) =>
  forBrands(theme, {
    gap: () => "text-align: center",
    gapfs: () => "text-align: center",
    at: () => `letter-spacing: 0.5px; background: ${theme.color.g6}`,
    br: () => `background-color: ${theme.color.b2}`,
    brfs: () => `background-color: ${theme.color.b2}`,
    default: () => "",
  }) as CSSObject;

export const StyledSubheadingContainer = styled.div(
  ({
    theme,
    isMobile,
    isBRRedesignEnabled,
    groupIndex,
  }: StyledContainerThemedProps) => {
    const getSubheadingFont =
      theme.brand === "on" ? theme.font.primary : theme.font.secondary;

    return css`
      ${isBRRedesignEnabled && groupIndex === 0 ? "display:none;" : ""}
      overflow: hidden;
      margin: 0;
      ${getBrandedMargins(theme)};
      padding: ${getPadding(theme, isMobile)};
      ${{...getSubheadingFont}}
      font-size: ${getFontSize(theme)};
      color: ${getColor(theme)};
      line-height: ${getLineHeight(theme)};
      ${customContainerStyles(theme)};
    `;
  }
);

export const SubheadingContainer = (props: StyledContainerProps) => (
  <StyledSubheadingContainer {...props} />
);
